// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1015px) and (max-width: 4000px) {
  body:has(.guest-login-wrapper) {
    overflow-y: hidden !important;
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* body:has(#root) {
    height: 100vh !important;
    position: relative;
    /* overflow-y: hidden !important; 
  } */

  .login-card {
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-card .card-info h4{
    font-size: 40px;
    margin-bottom: 15px;
  }

  .login-card .card-info p{
    font-size: 22px;
  }

  .login-card .swiper {
    min-width: 1000px;
  }

  .login-card .swiper .img-box {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .guest-login-wrapper {
    min-height: 100vh !important;
    padding: 0 4px;
    transform: scale(0.73);
    overflow-y: hidden;
    position: absolute;
    top: -5rem;
    left: 0;
    right: 0;
  }

  .guest-login-wrapper .next-btn{
    min-width: 700px;
    margin-left: 10px;
  }

  .guest-btn {
    min-width: 400px !important;
  }

  .login-btn {
    min-width: 400px;
  }

  .register-link p,
  .register-link a{
    font-size: 20px !important;
    margin-top: 20px !important;
  }
}

@media (min-width: 360px) and (max-width: 430px) {
  body:has(.guest-login-wrapper) {
    overflow-y: hidden !important;
  }

  /* body:has(#root) {
    height: 89vh !important;
    position: relative;
    overflow-y: hidden !important;
  } */

  .guest-login-wrapper {
    min-height: 89vh !important;
    padding: 0 4px;
    transform: scale(0.8);
    overflow-y: hidden;
    position: absolute;
    top: -3.44rem;
    left: 0;
    right: 0;
  }
}

.login-card {
  max-width: 390px;
  min-height: 524px;
  margin-left: auto;
  margin-right: auto;
}

.login-card .card-body {
  padding: 0 8px;
  margin-top: 14px;
  margin-bottom: 14px;
}

.login-card .heart-checker {
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.login-card .heart-checker .MuiButtonGroup-root {
  position: relative;
  right: -2.44rem !important;
}

.login-card .symptoms .MuiButtonGroup-root {
  max-width: 300px !important;
}

.guest-login-wrapper .MuiButtonGroup-root {
  border-radius: 30px;
  background: #edf9f9;
  max-width: 140px;
  box-shadow:
    0px 198px 55px 0px rgba(0, 0, 0, 0),
    0px 127px 51px 0px rgba(0, 0, 0, 0.01),
    0px 71px 43px 0px rgba(0, 0, 0, 0.05),
    0px 32px 32px 0px rgba(0, 0, 0, 0.09),
    0px 8px 17px 0px rgba(0, 0, 0, 0.1);
}

.login-card .m-choice-btns button {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
  border-radius: 20px !important;
  min-width: 70px !important;
  background: #edf9f9;
  border: none !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.login-card .m-choice-btns .MuiButton-containedPrimary {
  background: linear-gradient(92deg, #72d8da 1.54%, #35c6c9 94.34%) !important;
}

/* Utilities */

.login-card h4 {
  color: #000;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
  /* 116.667% */
}

.login-card .info-txt {
  color: #000;
  /* text-align: center; */
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  /* 147.059% */
}

.scan-btn {
  width: 174px !important;
  height: 37px !important;
  flex-shrink: 0 !important;
  border-radius: 30px !important;
  background: linear-gradient(92deg, #72d8da 1.54%, #35c6c9 94.34%);
  box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.4);
  color: #fff !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.loginSwiper .swiper-button-next,
.loginSwiper .swiper-button-prev {
  display: none;
}

.scan-img img {
  width: 167px;
  height: 167px;
}

.shadow-card {
  padding: 10px;
  min-height: 100px;
  border-radius: 10px;
  background: #f7f7f7;
  box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.1);
}

.wave-img {
  margin-bottom: 1.6rem !important;
}

.responsive-img {
  object-fit: cover;
}

.guest-login-wrapper .next-btn {
  width: 320px;
  height: 65px;
  flex-shrink: 0;
  border-radius: 40px;
  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);
  box-shadow:
    0px 35px 35px 0px rgba(0, 0, 0, 0.09),
    0px 9px 19px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.guest-btn {
  width: 235px !important;
  margin-left: 10px !important;
}

.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 40px !important;
  color: #35c6c9;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
  border: 3px solid #72d8da !important;
}

.skip-btn {
  color: #a1a0a0 !important;
  text-align: center;
  font-size: 17px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.register-link p,
.register-link a {
  color: #72d8da !important;
}

.register-link a,
.register-link p {
  margin-top: 6px;
}

.register-link a {
  font-weight: 600;
}

.guest-login-wrapper .swiper-pagination-bullet-active {
  background: #72d8da !important;
}

.guest-login-wrapper .MuiFilledInput-underline {
  border-radius: 40px !important;
}

.guest-login-wrapper .MuiFilledInput-underline:before,
.guest-login-wrapper .MuiFilledInput-underline::after {
  border-bottom: 0 !important;
}

.guest-login-wrapper .custom-input-email label {
  font-size: 19px !important;
  margin-left: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/GuestLogin/guestlogin.css"],"names":[],"mappings":"AAAA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;;KAIG;;EAEH;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;;;;KAIG;;EAEH;IACE,2BAA2B;IAC3B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;EACV;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB;;;;;uCAKqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,cAAc;;AAEd;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,iEAAiE;EACjE,+CAA+C;EAC/C,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iEAAiE;EACjE;;uCAEqC;EACrC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":["@media (min-width: 1015px) and (max-width: 4000px) {\n  body:has(.guest-login-wrapper) {\n    overflow-y: hidden !important;\n    min-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  /* body:has(#root) {\n    height: 100vh !important;\n    position: relative;\n    /* overflow-y: hidden !important; \n  } */\n\n  .login-card {\n    min-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .login-card .card-info h4{\n    font-size: 40px;\n    margin-bottom: 15px;\n  }\n\n  .login-card .card-info p{\n    font-size: 22px;\n  }\n\n  .login-card .swiper {\n    min-width: 1000px;\n  }\n\n  .login-card .swiper .img-box {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .guest-login-wrapper {\n    min-height: 100vh !important;\n    padding: 0 4px;\n    transform: scale(0.73);\n    overflow-y: hidden;\n    position: absolute;\n    top: -5rem;\n    left: 0;\n    right: 0;\n  }\n\n  .guest-login-wrapper .next-btn{\n    min-width: 700px;\n    margin-left: 10px;\n  }\n\n  .guest-btn {\n    min-width: 400px !important;\n  }\n\n  .login-btn {\n    min-width: 400px;\n  }\n\n  .register-link p,\n  .register-link a{\n    font-size: 20px !important;\n    margin-top: 20px !important;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 430px) {\n  body:has(.guest-login-wrapper) {\n    overflow-y: hidden !important;\n  }\n\n  /* body:has(#root) {\n    height: 89vh !important;\n    position: relative;\n    overflow-y: hidden !important;\n  } */\n\n  .guest-login-wrapper {\n    min-height: 89vh !important;\n    padding: 0 4px;\n    transform: scale(0.8);\n    overflow-y: hidden;\n    position: absolute;\n    top: -3.44rem;\n    left: 0;\n    right: 0;\n  }\n}\n\n.login-card {\n  max-width: 390px;\n  min-height: 524px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.login-card .card-body {\n  padding: 0 8px;\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n\n.login-card .heart-checker {\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.login-card .heart-checker .MuiButtonGroup-root {\n  position: relative;\n  right: -2.44rem !important;\n}\n\n.login-card .symptoms .MuiButtonGroup-root {\n  max-width: 300px !important;\n}\n\n.guest-login-wrapper .MuiButtonGroup-root {\n  border-radius: 30px;\n  background: #edf9f9;\n  max-width: 140px;\n  box-shadow:\n    0px 198px 55px 0px rgba(0, 0, 0, 0),\n    0px 127px 51px 0px rgba(0, 0, 0, 0.01),\n    0px 71px 43px 0px rgba(0, 0, 0, 0.05),\n    0px 32px 32px 0px rgba(0, 0, 0, 0.09),\n    0px 8px 17px 0px rgba(0, 0, 0, 0.1);\n}\n\n.login-card .m-choice-btns button {\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  border-radius: 20px !important;\n  min-width: 70px !important;\n  background: #edf9f9;\n  border: none !important;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.login-card .m-choice-btns .MuiButton-containedPrimary {\n  background: linear-gradient(92deg, #72d8da 1.54%, #35c6c9 94.34%) !important;\n}\n\n/* Utilities */\n\n.login-card h4 {\n  color: #000;\n  text-align: center;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 35px;\n  /* 116.667% */\n}\n\n.login-card .info-txt {\n  color: #000;\n  /* text-align: center; */\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 25px;\n  /* 147.059% */\n}\n\n.scan-btn {\n  width: 174px !important;\n  height: 37px !important;\n  flex-shrink: 0 !important;\n  border-radius: 30px !important;\n  background: linear-gradient(92deg, #72d8da 1.54%, #35c6c9 94.34%);\n  box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.4);\n  color: #fff !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n}\n\n.loginSwiper .swiper-button-next,\n.loginSwiper .swiper-button-prev {\n  display: none;\n}\n\n.scan-img img {\n  width: 167px;\n  height: 167px;\n}\n\n.shadow-card {\n  padding: 10px;\n  min-height: 100px;\n  border-radius: 10px;\n  background: #f7f7f7;\n  box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.1);\n}\n\n.wave-img {\n  margin-bottom: 1.6rem !important;\n}\n\n.responsive-img {\n  object-fit: cover;\n}\n\n.guest-login-wrapper .next-btn {\n  width: 320px;\n  height: 65px;\n  flex-shrink: 0;\n  border-radius: 40px;\n  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);\n  box-shadow:\n    0px 35px 35px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 19px 0px rgba(0, 0, 0, 0.1);\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.guest-btn {\n  width: 235px !important;\n  margin-left: 10px !important;\n}\n\n.login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 60px;\n  flex-shrink: 0;\n  border-radius: 40px !important;\n  color: #35c6c9;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration: none;\n  border: 3px solid #72d8da !important;\n}\n\n.skip-btn {\n  color: #a1a0a0 !important;\n  text-align: center;\n  font-size: 17px !important;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.register-link p,\n.register-link a {\n  color: #72d8da !important;\n}\n\n.register-link a,\n.register-link p {\n  margin-top: 6px;\n}\n\n.register-link a {\n  font-weight: 600;\n}\n\n.guest-login-wrapper .swiper-pagination-bullet-active {\n  background: #72d8da !important;\n}\n\n.guest-login-wrapper .MuiFilledInput-underline {\n  border-radius: 40px !important;\n}\n\n.guest-login-wrapper .MuiFilledInput-underline:before,\n.guest-login-wrapper .MuiFilledInput-underline::after {\n  border-bottom: 0 !important;\n}\n\n.guest-login-wrapper .custom-input-email label {\n  font-size: 19px !important;\n  margin-left: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
